<template>
  <div id="app">
    <wyplayer  ></wyplayer>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"  :key="$route.fullPath">
        <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>

    <transition v-if="$route.meta.transition" name="direction">
      <router-view v-if="!$route.meta.keepAlive" class="direction-view" ></router-view>
    </transition>

    <router-view v-if="!$route.meta.transition && !$route.meta.keepAlive" ></router-view>

    <!--<navigation>-->
      <!--<router-view></router-view>-->
    <!--</navigation>-->

    <van-tabbar @change="onChange" class="mytab" v-model="active" :active-color="active_color" placeholder  inactive-color="#999999" :route="false" safe-area-inset-bottom v-if="$route.meta.showTab">
      <van-tabbar-item :class="{'dark_theme': is_show_dark_theme}" v-if="icon.home.is_show" name="home" replace :to='{path: icon.home.go_url,query:{token:util.token}}'>
        <span>{{icon.home.name}}</span>
        <template #icon="props">
          <span class="iconfont font-size-21" :class="props.active?icon.home.icon:icon.home.icon"></span>
        </template>
      </van-tabbar-item>

      <van-tabbar-item :class="{'dark_theme': is_show_dark_theme}" v-if="icon.micro.is_show" name="micro" replace :to='{path: icon.micro.go_url,query:{token:util.token}}'>
        <span>{{icon.micro.name}}</span>
        <template #icon="props">
          <span class="iconfont font-size-21" :class="props.active?icon.micro.icon:icon.micro.icon"></span>
        </template>
      </van-tabbar-item>

      <van-tabbar-item :class="{'dark_theme': is_show_dark_theme}" v-if="icon.integral.is_show" name="integral" replace :to='{path: icon.integral.go_url,query:{token:util.token}}'>
        <span>{{icon.integral.name}}</span>
        <template #icon="props">
          <span class="iconfont font-size-21" :class="props.active?icon.integral.icon:icon.integral.icon"></span>
        </template>
      </van-tabbar-item>

      <van-tabbar-item :class="{'dark_theme': is_show_dark_theme}" v-if="icon.learning.is_show" name="learning" replace :to='{path: icon.learning.go_url,query:{token:util.token}}'>
        <span>{{icon.learning.name}}</span>
        <template #icon="props">
          <span class="iconfont font-size-21" :class="props.active?icon.learning.icon:icon.learning.icon"></span>
        </template>
      </van-tabbar-item>

      <van-tabbar-item :class="{'dark_theme': is_show_dark_theme}" v-if="icon.user.is_show" name="user" replace :to='{path: icon.user.go_url,query:{token:util.token}}'>
        <span>{{icon.user.name}}</span>
        <template #icon="props">
          <span class="iconfont font-size-21" :class="props.active?icon.user.icon:icon.user.icon"></span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
  import { Tabbar, TabbarItem } from 'vant';
  import wyplayer from '@/components/common/wyplayer';

  export default {
      components: {
          [Tabbar.name]: Tabbar,
          [TabbarItem.name]: TabbarItem,
          wyplayer,
      },
      name: "app",
      data(){
          return {
              active: 'home',
              active_key:'active',
              active_color: '#327CE9',
              transitionName: 'slide-right',
              is_show_dark_theme: false,
              icon:{
                  home:{
                      active: require('./assets/temp/home_all.png'),
                      inactive:require('./assets/temp/home.png'),
                      is_show: 1,
                      go_url: '/train/h5/home/index',
                      icon: 'iconshouye',
                      name: '首页',
                      id: ''
                  },
                  micro:{
                      active: require('./assets/temp/play_all2.png'),
                      inactive:require('./assets/temp/play.png'),
                      is_show: 0,
                      go_url: '/train/h5/learning_center/center',
                      icon: 'iconbofangbeifen13',
                      name: '小视频',
                      id: ''
                  },
                  integral:{
                      active:require('./assets/temp/integral_all.png'),
                      inactive:require('./assets/temp/integral.png'),
                      is_show: 0,
                      go_url: '/train/h5/integral/index',
                      icon: 'iconshouye',
                      name: '排行',
                      id: ''
                  },
                  learning:{
                      active:require('./assets/temp/xxzx_all.png'),
                      inactive:require('./assets/temp/xxzx.png'),
                      is_show: 1,
                      go_url: '/train/h5/learning_center/center',
                      icon: 'iconkaoshi1',
                      name: '学习中心',
                      id: ''
                  },
                  user:{
                      active:require('./assets/temp/my_all.png'),
                      inactive:require('./assets/temp/my.png'),
                      is_show: 1,
                      go_url: '/train/h5/user/index',
                      icon: 'icongaoliangwode',
                      name: '我的',
                      id: ''
                  }
              }
          }
      },
      activated () {
        console.log("APP.VUE activated调用了");
      },
      watch:{
        '$route' (to, from) {
          console.warn("watch",to.name)
          if(to.name=='micro/index' && from.name ){
            //TODO 太快导致无法获取
            setTimeout(() => {
              document.querySelector('.van-tabbar').setAttribute('style', 'background-color:#14131E;')
              this.setActiveTab()
            }, 300);
          }
        
        }
      },
      
      mounted() {
        this.getTabs()
        console.log('$route.fullPath',this.$route.fullPath)
        var name = window.location.pathname;
        if(name.indexOf('micro')>-1){ //如果是小视频模块 需要采用深色主题
          this.is_show_dark_theme = true
        }else{
          this.is_show_dark_theme = false
        }
      },
      methods:{
        setActiveTab(){
            var name = window.location.pathname;
            
            if(name.indexOf(this.icon.home.go_url)>-1){
              this.active = 'home';
            }else if(name.indexOf(this.icon.integral.go_url)>-1){
              this.active = 'integral';
            }else if(name.indexOf(this.icon.user.go_url)>-1){
              this.active = 'user';
            }else if(name.indexOf(this.icon.learning.go_url)>-1){
              this.active = 'learning';
            }else if(name.indexOf(this.icon.micro.go_url)>-1){
              this.active = 'micro';
              //this.active_color = '#FFFFFF';
            }
            if(this.is_show_dark_theme){
              this.active_color = '#FFFFFF';
            }
        },
        onChange(){
            if(this.is_show_dark_theme){
              this.active_color = '#FFFFFF'
              document.querySelector('.van-tabbar').setAttribute('style', 'background-color:#14131E;')
            }else{
              this.active_color= '#327CE9'
              document.querySelector('.van-tabbar').setAttribute('style', 'background-color:#FFF;')
            }
        },
        getTabs(){
           const _self = this
            this.util.server.mini_home.get_tabs({
                callback: (res => {
                    const { code, data, msg } = res;
                    if(code == 1) {
                        _self.icon.home = { ..._self.icon.home, ...data.home }
                        _self.icon.micro = { ..._self.icon.micro, ...data.micro }
                        _self.icon.integral = { ..._self.icon.integral, ...data.integral }
                        _self.icon.user = { ..._self.icon.user, ...data.user }
                        _self.icon.learning = { ..._self.icon.learning, ...data.learning }

                        _self.icon.home.go_url = data.home.id? data.home.go_url+'/'+data.home.id: data.home.go_url
                        _self.icon.integral.go_url = data.integral.id? data.integral.go_url+'/'+data.integral.id: data.integral.go_url
                        _self.icon.micro.go_url = data.micro.id? data.micro.go_url+'/'+data.micro.id: data.micro.go_url
                        _self.icon.user.go_url = data.user.id? data.user.go_url+'/'+data.user.id: data.user.go_url
                        _self.icon.learning.go_url = data.learning.id? data.learning.go_url+'/'+data.learning.id: data.learning.go_url

                        _self.setActiveTab()
                    }
                }),
                is_show_load: false
            });
        }
      }
  }
</script>
<style>
  body {
    font-size: 14px;
    background-color: #f8f8f8;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  div{
    font-size: 14px;
  }
  .page__bd_spacing {
    padding: 15px 10px;
  }

  .btn-hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  }

  .flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
  }

  .flex__item {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }

  .flex .placeholder {
    margin: 5px;
    padding: 16px;
    background-color: #fff;
    border-radius: 4px;
  }

  .grids {
    position: relative;
    overflow: hidden;
  }

  .grid {
    position: relative;
    float: left;
    padding: 5px;
    width: 49.999999%;
    box-sizing: border-box;
  }

  .cells {
    padding: 5px 15px;
    margin-top: 10px;
    background-color: #fff;
    line-height: 1.41176471;
    font-size: 14px;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
  }

  .cell {
    padding: 12px 0;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .cell-hover{
    background-color: #f8f9fb;
  }

  .cell-line {
    border-top: 1px solid #f8f9fb;
  }

  .cell-line-bottom {
    border-bottom: 1px solid #f8f9fb;
  }

  .cell__icon {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }

  .cell__bd {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }

  .cell__label {
    width: 80px;
  }

  .cell__edit image{
    width: 16px;
    height: 16px;
  }

  .cell__right {
    text-align: right;
    font-size: 12px;
    color: #dadada;
  }

  .cell__opr {
    width: 25px;
  }

  .cell__opr:after {
    content: " ";
    display: inline-block;
    height: 8px;
    width: 8px;
    border-width: 1px 1px 0 0;
    border-color: #dadada;
    border-style: solid;
    -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    top: -2px;
    position: absolute;
    top: 50%;
    right: 4px;
    margin-top: -5px;
  }


  .tab {
    width: 200px;
    margin: 10px auto;
  }

  .tab-item {
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    border-bottom-width: 5px;
    border-bottom-style: solid;
    border-bottom-color: transparent;
  }
  .tab-line{
    width: 50%;
    background-color: transparent;
    border-radius: 4px;
    height: 5px;
    margin: 0 auto;
  }
  .tab-select .tab-line{
    background-color: #327CE9;
  }

  .yellow {
    color: #ff7f3e;
    font-size: 15px;
  }

  .blue {
    color: #327ce9;
    font-size: 15px;
  }
  .right{
    text-align: right
  }
  .center {
    text-align: center;
  }

  .button {
    width: 180px;
    height: 38px;
    line-height: 38px;
    background: #327ce9;
    color: #fff;
    border-radius: 4px;
    margin: 0 auto;
    text-align: center;
  }
  .font-size-21{
    font-size: 21px !important
  }
</style>
<style scoped>
  .van-tabbar-item__icon img{
    height: 24px;
  }
  .van-tabbar-item__text span{
    font-size: 12px;
  }
  .dark_theme{
    background-color: #14131E;
  }

  .direction-enter,
  .direction-leave-to {
    transform: translate3d(100%, 0, 0);
  }

  /* 注意这里的样式可能会导致子页面问题  app*/
  /* TODO 由于overflow: hidden 导致无法下拉 */
  .direction-view {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100vw;
    z-index: 100;
    /* overflow: hidden;  */
    overflow-y: scroll; 
    transition: transform 0.3s;
  }
  /* 注意这里的样式可能会导致子页面问题  direction-view */
  #app{
    position: relative;
    max-width: 480px;
    margin: 0 auto;
    height: 100%;
  }
  .mytab >>> .van-tabbar{
    max-width: 480px;
    margin: 0 auto;
    right: 0;
    z-index: 2;
  }
</style>
